import React from "react"
import game from "battle-submarine.png"

const BattleSubmarine = props => <img src={game} className="game" {...props} />

export default BattleSubmarine
